/**
 * THE ARRIVAL SCREEN — the only phase where the page can speak before the bundle exists.
 *
 * The markup carries the ENGLISH of these strings written flat in `index.html`, because this catalogue
 * arrives inside the bundle this screen exists to narrate. What `t()` does here is replace them once the
 * bundle lands, which is also the first proof that the language was applied.
 */
export default {
  engine: 'Ballistic engine',
  starting: 'starting the simulator',
  warming: 'warming the catalogue',
  /** The room is being opened on the coordination plane, which takes a round trip and a subscription. */
  opening_room: 'opening the room — waiting for the coordination plane',
  /** This tab is being sent to sign in and will come straight back (`shared/coord/bearer.ts`). */
  signing_in: 'signing in — this tab will come back',
  connecting_local: 'connecting to the local match',
  building_local: 'building the local match — {field}',
  tagline: 'Real ballistics · Real tactics · Real airsoft',
  // What the counter says while files come down. The figures are the loader's own.
  files: '{done}/{total} files',
  failed: '{n} not fetched',

  // ── the phases after the catalogue, which are the ones that can stall ─────────────────────────────
  connecting_field: 'connecting to the field',
  arming_field: 'building the field',
  // A warm-up that gave up waiting and one that finished look identical from the menu, and the
  // difference is whether the field about to be walked into has holes in it.
  partial: 'starting anyway — what is missing arrives later',
  // A WAY IN THAT NEVER ARRIVES HAS TO SAY SO, and say something that can be acted on. Otherwise the
  // progress line reads "connecting" for as long as the tab is open, with the real notice behind it at
  // zero pixels. Each names its own suspect, because the two are fixed in different places.
  local_failed: 'could not build the local match: {err}',
  local_stalled: 'the local match is not starting — reload the page; if it persists, the worker did not load',
  field_silent: 'the field is not answering — reload the page; if it persists, the service is not listening',

  // ── LA NEGATIVA CON TACTO (`hosted.md §7.3`, T7) ──────────────────────────────────────────────────
  // Three lines and the order is the message: what happened, the measured cause, and the way out. The
  // way out is never a retry — this machine will refuse again in the same second — so it names the one
  // move a person actually has, which is somebody else opening the room.
  /** The aptitude check, which runs while the player waits and before any room is announced (§7). */
  checking_host: 'checking this machine can host — reach and cadence',
  unfit_title: 'Your machine cannot host this match',
  // The two causes are separate because the two ways out are. A connection nobody can reach is not fixed
  // by choosing a lighter field, and a field this processor cannot carry is not fixed by anything else.
  unfit_unreachable: 'your connection does not allow direct connections, and no relay answered',
  unfit_slow: 'the processor does not sustain the field you chose ({field})',
  unfit_out: 'You can still play it: ask somebody else in the group to open it from their machine.',
  unfit_facts: 'measured · {facts}',
};
